import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-time-stamp-start-corr',
  templateUrl: './time-stamp-start-corr.component.html',
  styleUrls: ['./time-stamp-start-corr.component.css']
})
export class TimeStampStartCorrComponent implements OnInit {
    labourNo;

    public edit?: Edit;

    public grid?: GridOptions;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadEdit() {
        if (!!this.labourNo) {
            this.edit = (await this.datatask.Post(2587, { labour_no: this.labourNo }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_timestampstartcorr_powtimes_grid')
                .setLoadDataFunction({
                    method: 2589,
                    parameters: () => this.edit
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2588, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back(2);
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'timestamp_start':
            case 'timestamp_end':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    labour_no: string;
    labour_name: string;
    timestamp_start: string;
    force_timestamp_end: string;
    timestamp_end: string;
}
